import axios from "axios";
import { triggerSessionAlert } from "../utils/SessionAlertHelper";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Add new user
export const addAdminUser = async (payload, userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/manage-user?userId=${userId}`, payload, {
      withCredentials: true,
    });

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching admins.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const getAdminUsersData = async (params = {}) => {
  try {
    const { searchTerm = "", page = 1, limit = 10, userId } = params;
    const response = await axios.get(
      `${API_BASE_URL}/manage-user?userId=${userId}&page=${page}&limit=${limit}&search=${searchTerm}`,
      { withCredentials: true }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.admins,
      totalPages: response.data.data.totalPages,
      currentPage: response.data.data.currentPage,
      totalCount: response.data.data.totalAdmins,
    };
  } catch (error) {
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message: "Cannot connect to the server. Please check your network or try again later.",
        error: { code: "NETWORK_ERROR", message: error.message || "Network Error" },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred while fetching admins.",
      error: error.response?.data?.error || { code: error.response?.status || 500, message: error.message },
    };
  }
};

export const updateAdminUser = async (payload, userId) => {
   try {
    const response = await axios.patch(
      `${API_BASE_URL}/manage-user/specific?userId=${userId}`,
      payload,
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Admin access updated successfully.",
      data: response.data.data.customer,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating admin.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const deleteAdminUser = async (userId, adminId) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/manage-user/${userId}?userId=${adminId}`,
      
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Admin deleted successfully",
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while deleting customer.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};